var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBuildings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9H13C12.6023 9.00046 12.2211 9.15864 11.9398 9.43984C11.6586 9.72105 11.5005 10.1023 11.5 10.5V13.5H8.5C8.10232 13.5005 7.72105 13.6586 7.43984 13.9398C7.15864 14.2211 7.00046 14.6023 7 15V22.5H22V10.5C21.9995 10.1023 21.8414 9.72105 21.5602 9.43984C21.2789 9.15864 20.8977 9.00046 20.5 9ZM8.5 21V15H11.5V21H8.5ZM20.5 21H13V10.5H20.5V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12H14.5V15H16V12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H17.5V15H19V12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5H14.5V19.5H16V16.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.5H17.5V19.5H19V16.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 22.5C3.1023 22.4996 2.72101 22.3414 2.4398 22.0602C2.15859 21.779 2.00042 21.3977 2 21V3C2.00042 2.6023 2.15859 2.22101 2.4398 1.9398C2.72101 1.65859 3.1023 1.50042 3.5 1.5H15.5C15.8977 1.50042 16.279 1.65859 16.5602 1.9398C16.8414 2.22101 16.9996 2.6023 17 3V7.5H15.5V3H3.5V21H5.5V22.5H3.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.5H5V6H14V4.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5H5V9H10V7.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5H5V12H9V10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuildings);
export default __webpack_public_path__ + "static/media/ic-buildings.ee8a379b886fea50d72c63e30a59e226.svg";
export { ForwardRef as ReactComponent };